import { ComponentProps } from 'react';
import { ChakraComponent, List } from '@chakra-ui/react';

import * as Subcomponents from './subcomponents';

type OBListProps = ComponentProps<typeof List>;

/**
 * A <ul><li> styled component
 */
const OBList: typeof Subcomponents & ChakraComponent<'ul', OBListProps> = ({
  children,
  ...props
}) => (
  <List spacing="space-16" {...props}>
    {children}
  </List>
);

OBList.Item = Subcomponents.Item;

export default OBList;
